import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfFabricados {
  static async gerarRelatorio(
    distrito,
    fabricadosMapImage,
    produtosFabricadosImage,
  ) {
    const [propriedades, areaMedia, produtosFabricadosData] = await Promise.all(
      [
        Api.getNumeroPropriedades2(
          distrito,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ),
        Api.getAreaMediaDistrito(distrito),
        Api.getProdutosFabricados(distrito),
      ],
    );

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades.value,
      areaMedia.value,
      fabricadosMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(
      doc,
      produtosFabricadosData.value,
      produtosFabricadosImage,
      imgSize,
    );

    const fileName =
      "Relatorio_Produtos_Fabricados_" +
      distrito +
      "_" +
      this.dataAtual() +
      ".pdf";
    doc.save(fileName);
  }

  static pageOne(doc, distrito, propriedades, areaMedia, fabricadosMapImage) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [["Distrito:", distrito || "Não informado"]];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades:   ", propriedades],
      ["Área média:   ", areaMedia.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(fabricadosMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(
    doc,
    produtosFabricadosData,
    produtosFabricadosImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      produtosFabricadosImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - 50,
      y,
      100,
      150,
    );

    y += 160;

    doc.text(
      `Observa-se que ${produtosFabricadosData["Farinha"]} propriedades declararam produzir farinha, ${produtosFabricadosData["Açucar Mascavo"]} açúcar mascavo, ${produtosFabricadosData["Cristalizados"]} cristalizados, ${produtosFabricadosData["Defumados"]} defumados, ${produtosFabricadosData["Desidratados"]} desidratados, ${produtosFabricadosData["Povilho"]} povilho e ${produtosFabricadosData["Rapadura"]} rapadura. ${produtosFabricadosData["Polpas de Sucos"]} propriedades relataram produzir polpas de sucos, enquanto ${produtosFabricadosData["Queijo"]} informaram fabricar queijo. Registrou-se ainda a produção de cachaça por ${produtosFabricadosData["Cachaça"]} propriedades, licores por ${produtosFabricadosData["Licores"]}, fubá por ${produtosFabricadosData["Fubá"]}, doces por ${produtosFabricadosData["Doces"]} e quitandas por ${produtosFabricadosData["Quitandas"]} propriedades. Por fim, ${produtosFabricadosData["Outros"]} propriedades indicaram produzir outros tipos de produtos.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de produtos fabricados das propriedades",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "rurais cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfFabricados;
